'use client';

import { useInquiryStore } from '@/store/about/useInquiryStore';
import InquiryButton from '../../_components/InquiryButton';

export default function Counsel() {
  const { isComplete, phone } = useInquiryStore();

  if (isComplete) {
    return (
      <>
        <div className="headline">
          <h1 className="title">
            상담 문의가 정상적으로
            <br />
            접수되었습니다.
          </h1>
          <p className="desc">이실장 상담사가 빠른시일내에 전화드리겠습니다.</p>
        </div>
        <div className="btn btn_rounded_primary xl">
          {phone}로
          <br />
          빠른 시일 내에 전화드리겠습니다.
        </div>
      </>
    );
  }
  return (
    <>
      <div className="headline">
        <h1 className="title">궁금한 점이 있으신가요?</h1>
        <p className="desc">상담사가 빠른 시일내에 전화드리겠습니다.</p>
      </div>
      <InquiryButton position={'inquiry'} />
    </>
  );
}
